import request from '../utils/request'

export function modifyProductPrice(price) {
    return request({
        url: '/api/product/price/modify',
        method: 'post',
        data: price
    })
}

export function importProductPrices(file) {
    const formDate = new FormData()
    formDate.append('file', file)
    return request.request({
        url: '/api/product/price/import',
        method: 'post',
        data: formDate
    })
}

export function deleteProductPrice(id) {
    return request.request({
        url: '/api/product/price/delete',
        params: {price_id: id}
    })
}

export function updateOrderPriceStatus(id) {
    return request.request({
        url: '/api/product/price/update',
        method: 'POST',
        data: {price_id: id}
    })
}